import Vue from 'vue'

Vue.config.devtools = process.env.VUE_APP_ENV !== 'production'
Vue.config.productionTip = false

import App from './App'
import router from './router'

import Assets from '@/assets'
import ThirdParty from '@/third-party'

import '@/components/install'

Vue.use(Assets)
Vue.use(ThirdParty)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_ENABLE_TAILWIND_DEBUG_SCREENS === 'true') {
  document.body.classList.add('debug-screens')
}
